import { render, staticRenderFns } from "./nutritionMealDialogBarcodereader.vue?vue&type=template&id=3462db08"
import script from "./nutritionMealDialogBarcodereader.vue?vue&type=script&lang=js"
export * from "./nutritionMealDialogBarcodereader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports